module.exports = "<span class=\"spinner spinner-default\"></span> ";